import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'rsm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('officer-events', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      month: filter.month,
      area: filter.area,
      officer: filter.officer,
      activity: filter.activity,
      event_date: filter.event_date
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('officer-events')
}

export {
  setTableOptions,
  getTableOptions
}
